
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface NurseNotesParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}

export interface NurseNotes {
  id?: any;
  regId: any;
  admissionId:any;
  notes:string;
  powerToneReflex?:string;
  painLevel:string;
  createdBy:any;
  createdDate:any;
  dateTime:any;
  shiftId:any;
  nurseId:any;
  tenantId: any;
  branchId: any;
  visitId?:any;

  parameters?: NurseNotesParameter[];
  links?: any;
}

export abstract class NurseNotesData {
    //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
    abstract list(url: string): Observable<NurseNotes[]>;
    abstract create(url: string, data: NurseNotes): Observable<NurseNotes>;
    abstract update(url: string, data: NurseNotes): Observable<NurseNotes>;
    abstract delete(url: string): Observable<any>;
   
  }


